/* eslint-disable */
import React, { Component } from 'react';
import { Select } from 'antd';
import { apiClient } from '../../../api';
import{root} from '../../../config';
import { token, CheckTokenExp } from '../../../config';
import ModalServerError from '../Modal/ModalServerError';

const { Option } = Select;

export default class SelectCampaign extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            list: [],
            select: [],
            accounts: [],
            users: [],
            sender: [],
            modalVisible: false,
        };

        this.getData = this.getData.bind(this);

    }

    componentDidMount() {
        // ไม่เรียก API ทันที รอให้มี accounts ก่อน
        // this.getData("", this.state.accounts, this.state.users, this.state.sender);
    }


    componentWillReceiveProps(nextProps) {

        if (this.props.accounts !== nextProps.accounts) {
            this.setState({ accounts: nextProps.accounts }, () => { 
                // เรียก API เฉพาะเมื่อ accounts เปลี่ยน
                this.getData("", this.state.accounts, this.state.users, this.state.sender) 
            })
           
        }

        // ไม่เรียก API เมื่อ users เปลี่ยน เพราะจะทำให้เกิด loop
        if (this.props.users !== nextProps.users) {
            this.setState({ users: nextProps.users });
        }

        if (this.props.sender !== nextProps.sender) {
            this.setState({ sender: nextProps.sender }, () => {  
                // เรียก API เฉพาะเมื่อ sender เปลี่ยน
                this.getData("", this.state.accounts, this.state.users, this.state.sender)
            })
           
        }

       
    }


    getData(value, accounts, users, sender) {
        if (!CheckTokenExp()) {
            // ป้องกันการเรียก API ซ้ำถ้ายัง loading อยู่
            if (this.state.loading) {
                return;
            }
            
            // ป้องกันการเรียก API เมื่อไม่มี accounts
            if (!accounts || accounts.length === 0) {
                return;
            }
            
            this.state.list.length > 0 ? "" : this.setState({ loading: true });
            let req = JSON.stringify({
                name: value,
                accountid: accounts,
                userid: users,
                sendername: sender,


            });

            apiClient.post('api/Report/OtpList_createreport', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    },
                    timeout: 5000 // เพิ่ม timeout 5 วินาที
                })
                .then(data => {
                    if (data.status === 200) {
                        // ไม่แสดง popup แม้ว่า data จะเป็น empty array
                        this.setState({ list: data.data || [] });
                    } else {
                        // แสดง popup เฉพาะเมื่อ status ไม่ใช่ 200
                        this.setState({ modalVisible: true });
                        this.setState({ list: [] });
                    }
                    this.setState({ loading: false });
                })
                .catch(error => {
                    // แสดง popup เฉพาะเมื่อเกิด network error
                    this.setState({ modalVisible: true });
                    this.setState({ list: [] });
                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }

    }

    render() {
        const { loading, list, modalVisible } = this.state;
        const { placeholder, mode, disablestatus, select, setStateByProps, by, style, accounts, users, sender, otp } = this.props;
        return (
            <>
                <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    disabled={disablestatus == true ? true : false}

                    style={style ? style : null}
                    loading={loading}
                    onSearch={(value) => { this.getData(value, accounts, users, sender) }}
                    onChange={(value) => { setStateByProps("otp", value) }}
                    value={select}
                    suffixIcon={loading ? "" : <span className="fa fa-angle-down" />}
                    placeholder={placeholder ? placeholder : "Enter new sender name or select from options here."}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {
                        list.map((item, index) =>
                            <Option key={index} value={item.ID}>{item.TEXT}</Option>
                        )
                    }
                </Select>
                <ModalServerError modalVisible={modalVisible}/>
            </>
        );
    }
}


